import { ReactNode } from 'react';

export enum AlertBoxType {WARNING = 'WARNING', INFO = 'INFO', ERROR = 'ERROR'}
export interface AlertBoxData {
    show: boolean,
    title: string,
    messageNode: ReactNode,
    acceptText: string,
    acceptCallback: () => void,
    cancelText?: string,
    cancelCallback?: () => void,
    type?: AlertBoxType,
}
